import React from 'react';
import { profileData } from '../data/mock';

const Skills = () => {
  const skillCategories = [
    { title: 'Languages', skills: profileData.skills.languages },
    { title: 'Frameworks & Tools', skills: profileData.skills.frameworks },
    { title: 'Databases', skills: profileData.skills.databases },
    { title: 'Concepts', skills: profileData.skills.concepts }
  ];

  return (
    <section className="py-24 px-6 bg-gray-50 dark:bg-gray-800/50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 opacity-0 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Technical Skills
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-900 rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 opacity-0 animate-fadeInUp"
              style={{ animationDelay: `${200 + index * 100}ms` }}
            >
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6">
                {category.title}
              </h3>
              <div className="flex flex-wrap gap-3">
                {category.skills.map((skill, idx) => (
                  <span
                    key={idx}
                    className="px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium hover:bg-blue-100 dark:hover:bg-blue-900/30 hover:text-blue-600 dark:hover:text-blue-400 transition-all duration-300 transform hover:scale-105 cursor-default"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;